module.exports = __webpack_public_path__ + "img/sfz.b7682bd6.png";